import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { TabsModule } from 'primeng/tabs';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { ListarInstituicoesEnsinoBolseiroComponent } from '../listar-instituicoes-ensino-bolseiro/listar-instituicoes-ensino-bolseiro.component';
// import { ListarBolseirosComponent } from '../listar-bolseiros/listar-bolseiros.component';
import { DividerModule } from 'primeng/divider';
import {
  PaisService,
  ProvinciaService,
  MunicipioService,
  CommunicationService,
  BolseiroService,
  UtilizadorService,
  BolsaService,
  EnumService,
} from '../../api/services';
import { ApiService } from '@core/providers/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { forkJoin, Observable, Subscription, tap } from 'rxjs';
import { CadastrarBolseirosComponent } from '../../bolseiros/cadastrar-bolseiros/cadastrar-bolseiros.component';
import { ToastModule } from 'primeng/toast';
import { Bolseiro } from '../../api/models/bolseiro.model';
import { ListarBolsaBolseirosComponent } from '../listar-bolsa-bolseiros/listar-bolsa-bolseiros.component';
import { FilterItem } from '../../api/models';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PanelModule } from 'primeng/panel';
import { Chip, ChipModule } from 'primeng/chip';
import { PrimeIcons } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { MaisDetalheEstudanteComponent } from './mais-detalhe-estudante/mais-detalhe-estudante.component';
import { ListaDadoFinanceiroComponent } from '../lista-dado-financeiro/lista-dado-financeiro.component';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  standalone: true,
  selector: 'app-detalhe-bolseiro',
  imports: [
    CommonModule,
    BackButtonComponent,
    ButtonModule,
    TabsModule,
    SearchBarComponent,
    ListarInstituicoesEnsinoBolseiroComponent,
    ListarBolsaBolseirosComponent,
    // ListarBolseirosComponent,
    ToastModule,
    TableModule,
    TagModule,
    DrawerModule,
    DividerModule,
    PanelModule,
    ChipModule,
    ConfirmDialog,
    MaisDetalheEstudanteComponent,
    ListaDadoFinanceiroComponent,
    Chip,
    AvatarModule,
  ],
  providers: [
    DialogService,
    ApiService,
    PaisService,
    ProvinciaService,
    MunicipioService,
    CommunicationService,
    BolseiroService,
    UtilizadorService,
    BolsaService,
    MessageService,
    ConfirmationService,
    EnumService,
  ],
  templateUrl: './detalhe-bolseiro.component.html',
  styleUrls: ['./detalhe-bolseiro.component.scss'],
})
export class DetalheBolseiroComponent implements OnInit {
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
  dialogService = inject(DialogService);
  paisService = inject(PaisService);
  provinciaService = inject(ProvinciaService);
  municipioService = inject(MunicipioService);
  communicationService = inject(CommunicationService);
  bolseiroService = inject(BolseiroService);
  utilizadorService = inject(UtilizadorService);
  messageService = inject(MessageService);
  bolsaService = inject(BolsaService);
  route = inject(ActivatedRoute);
  bolseiroID!: string;
  isLoading: boolean = false;
  enumService = inject(EnumService);
  bolseiro: any = null;
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  utilizadores: any[] = [];
  private subscriptions = new Subscription();

  maisDetalheEstudante: Bolseiro | undefined | null;
  @Output() onCloseModal = new EventEmitter<boolean>();
  showDetalhe: boolean = false;

  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL

  sortFields: any[] = [
    {
      label: 'Nome',
      value: 'nome',
    },
  ];

  estado = [
    { id: 1, designacao: 'Activo' },
    { id: 2, designacao: 'Inactivo' },
  ];

  tipoBolsaOptions: any[] = [
    { id: 1, designacao: 'Interna' },
    { id: 2, designacao: 'Externa' },
  ];

  niveisAcademicos = [
    { label: 'Ensino Primário', id: 1 },
    { label: 'Ensino Primário (1º Ciclo)', id: 2 },
    { label: 'Ensino Primário (2º Ciclo)', id: 3 },
    { label: 'Bacharelato', id: 4 },
    { label: 'Licenciatura', id: 5 },
    { label: 'Pós-graduação', id: 6 },
    { label: 'Mestrado', id: 7 },
    { label: 'Doutoramento (PhD)', id: 8 },
    { label: 'Pós-doutoramento', id: 9 },
  ];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'BolseiroID',
      placeholder: 'Pesquise pelo numero do bolseiro',
    },
    {
      type: 'dropdown',
      controlName: 'TipoBolsaID',
      placeholder: 'Tipo de bolsa',
      options: this.tipoBolsaOptions,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'NivelAcademico',
      placeholder: 'Grau Académico',
      options: this.niveisAcademicos,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoBolsa',
      placeholder: 'Estado',
      options: this.estado,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];

  estados = [
    { id: 'ativo', designacao: 'Activo' },
    { id: 'inativo', designacao: 'Inactivo' },
  ];

  tiposDeBolsa = [
    { id: 'parcial', designacao: 'Parcial' },
    { id: 'integral', designacao: 'Integral' },
  ];

  nacionalidades = [
    { label: 'Angola', id: 1 },
    { label: 'Namibiana', id: 2 },
  ];

  estadoCivilOptions = [
    { label: 'Solteiro', id: 1 },
    { label: 'Casado', id: 2 },
  ];

  generoOptions = [
    { label: 'Masculino', id: 1 },
    { label: 'Feminino', id: 2 },
  ];

  nivelAcademicoOptions = [
    { label: 'Base', id: 1 },
    { label: 'Médio', id: 2 },
    { label: 'Licenciado', id: 3 },
  ];

  provincias = [
    { label: 'Luanda', id: 1 },
    { label: 'Benguela', id: 2 },
    { label: 'Huambo', id: 3 },
  ];

  municipios = [
    { label: 'Cazenga', id: 1 },
    { label: 'Viana', id: 2 },
    { label: 'Cacuaco', id: 3 },
  ];
  aproveitamentoOptions: any[] = [];
  estadoOptions: any[] = [];
  estadoMatriculaOptions: any[] = [];
  universityName = 'Bolseiro de Mérito Académico';
  totalRecords = 0;
  page = 1;
  rows = 10;
  private readonly ESTADO_BOLSA_ATIVO = 2; // "Activo"
  private readonly APROVEITAMENTO_EM_CURSO = 2; // "Em Curso"
  private readonly ESTADOS_MATRICULA_VALIDOS = new Set([2]); // 0 "Aprovado", 2 "Em Curso"

  currentAnoCurricular: string | null = null;

  semFaseFormacao = false;
  matriculaNaoFeita = false;
  constructor(private router: Router) {
    this.loadCountries();
    this.loadEnums().subscribe();
  }

  ngOnInit(): void {
    this.bolseiroID = this.route.snapshot.paramMap.get('id')!;
    this.getBolseiroDetails(this.bolseiroID);
    this.subscriptions.add(
      this.communicationService.countryChanged$.subscribe(
        (country: string | null) => {
          if (country) {
            this.loadProvinces(country);
          }
        }
      )
    );

    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.loadImagemInstituicao(id);
    }

    this.subscriptions.add(
      this.communicationService.provinceChanged$.subscribe(
        (province: string | null) => {
          if (province) {
            this.loadMunicipalities(province);
          }
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadEnums(): Observable<any> {
    return forkJoin({
      estadoBolsa: this.enumService.getAllEstadoBolsaEnum(),
      estadoMatricula: this.enumService.getAllEstadoMatriculaEnum(),
      estadoBolsaCurso: this.enumService.getAllEstadoBolsaCursoEnum(),
    }).pipe(
      tap((response) => {
        if (response.estadoBolsa?.data) {
          //         {
          //   "1": "Enquadrado",
          //   "2": "Activo",
          //   "3": "Suspenso",
          //   "4": "Cancelado",
          //   "5": "Concluído"
          // }
          this.estadoOptions = Object.entries(response.estadoBolsa.data).map(
            ([key, value]) => ({ id: Number(key), designacao: value })
          );
        }
        if (response.estadoBolsaCurso?.data) {
          //         {
          //   "1": "Pendente",
          //   "2": "Em Curso",
          //   "3": "Finalizado",
          //   "4": "Reprovado"
          // }
          this.aproveitamentoOptions = Object.entries(
            response.estadoBolsaCurso.data
          )
            // .filter(([key]) => key === '1' || key === '2') // apenas "Pendente" e "Em Curso"
            .map(([key, value]) => ({
              id: Number(key),
              designacao: value,
            }));
          console.log('Aproveitamento Options:', this.aproveitamentoOptions);
        }

        if (response.estadoMatricula?.data) {
          //         {
          //   "0": "Aprovado",
          //   "1": "Reprovado",
          //   "2": "Em Curso",
          //   "3": "Suspenso",
          //   "4": "Pendente"
          // }
          this.estadoMatriculaOptions = Object.entries(
            response.estadoMatricula.data
          ).map(([key, value]) => ({ id: Number(key), designacao: value }));
        }
      })
    );
  }

  loadCountries() {
    this.paisService.list().subscribe((countries) => {
      this.countries = countries;
    });
  }

  loadProvinces(country: string) {
    this.provinciaService.list(country).subscribe((provinces) => {
      this.provinces = provinces;
      this.communicationService.updateProvinces(provinces);
      this.municipalities = [];
    });
  }

  loadMunicipalities(province: string) {
    this.municipioService.list(province).subscribe((municipalities) => {
      this.municipalities = municipalities;
      this.communicationService.updateMunicipalities(municipalities);
    });
  }

  // +++ NOVO: helpers no topo da classe
  private normalize(s: any) {
    return String(s ?? '')
      .trim()
      .toLowerCase();
  }

  matriculaAtual: any | null = null;
  currentCurso: string | null = null;
  currentFase: string | null = null;
  currentUnidInst: string | null = null;

  // SUBSTITUI a computeCurrentAnoCurricular por esta (ou chama-a daqui)
  private resolveMatriculaAtualFromTop(): void {
    this.matriculaAtual = null;
    this.currentAnoCurricular = null;
    this.currentCurso = null;
    this.currentFase = null;
    this.currentUnidInst = null;

    const arr = Array.isArray(this.bolseiro?.matricula)
      ? this.bolseiro.matricula
      : [];
    if (!arr.length) return;

    // 1) prioridade para "Em Curso"
    const emCurso = arr.find(
      (m: any) => this.normalize(m?.estadoDescricao) === 'em curso'
    );

    // 2) senão, a mais recente por dataInicio
    const byRecent =
      emCurso ??
      arr
        .slice()
        .sort(
          (a: any, b: any) =>
            (b?.dataInicio ? new Date(b.dataInicio).getTime() : 0) -
            (a?.dataInicio ? new Date(a.dataInicio).getTime() : 0)
        )[0];

    this.matriculaAtual = byRecent ?? null;

    if (this.matriculaAtual) {
      this.currentAnoCurricular = String(
        this.matriculaAtual.anoCurricular ?? ''
      );
      this.currentCurso = this.matriculaAtual.curso ?? null;
      this.currentFase = this.matriculaAtual.fase ?? null;
      this.currentUnidInst = [
        this.matriculaAtual.instituicaoEnsino,
        this.matriculaAtual.unidadeOrganica,
      ]
        .filter(Boolean)
        .join(' — ');
    }
  }

  // >>> chame no getBolseiroDetails, depois de definir this.bolseiro
  getBolseiroDetails(bolseiroID: string) {
    this.bolseiroService.show(bolseiroID).subscribe(
      (reponse: any) => {
        this.bolseiro = reponse.data;
        this.resolveMatriculaAtualFromTop(); // <<< AQUI
      },
      (error: any) => {
        console.error('Erro ao buscar detalhes do bolseiro:', error);
      }
    );
  }

  loadImagemInstituicao(id: number) {
    this.bolseiroService.getBolseiroFotoById(id).subscribe({
      next: (response) => {
        if (!response || !response.type.startsWith('image/')) {
        console.warn('Resposta não é imagem. A usar placeholder.');
        this.imagePreview = null;
        return;
      }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error('Erro ao carregar imagem da instituição:', err);
        this.imagePreview = null;
      },
    });
  }

  toggleBolseiroStatus() {
    this.bolseiroService.toggleStatus(this.bolseiroID).subscribe(
      (isActive) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Estado do bolseiro alterado com sucesso!`,
        });
        this.getBolseiroDetails(this.bolseiroID);
      },
      (error) => {
        console.error('Erro ao alterar status do bolseiro:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao alterar status do bolseiro.',
        });
      }
    );
  }

  showDialog() {
    // const ref = this.dialogService.open(CadastrarBolseirosComponent, {
    //   showHeader: false,
    //   width: '50%',
    //   modal: true,
    //   data: {
    //     utilizadores: this.utilizadores,
    //     nacionalidades: this.nacionalidades,
    //     estadoCivilOptions: this.estadoCivilOptions,
    //     generoOptions: this.generoOptions,
    //     nivelAcademicoOptions: this.nivelAcademicoOptions,
    //     provincias: this.provincias,
    //     municipios: this.municipios,
    //     tiposDeBolsa: this.tiposDeBolsa,
    //     estados: this.estados,
    //   },
    // });
    // ref.onClose.subscribe((data) => {
    //   if (data) {
    //     this.storeBolseiro(data);
    //   }
    // });
  }

  storeBolseiro(data: any) {
    this.isLoading = true;
    this.bolseiroService.store(data).subscribe(
      () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Bolseiro criado com sucesso!',
        });
      },
      (error) => {
        console.error('Erro ao criar bolseiro:', error);
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao criar bolseiro.',
        });
      }
    );
  }

  clickMaisDetalhe(estudante: Bolseiro) {
    this.maisDetalheEstudante = estudante;
    this.showDetalhe = true;
  }

  GotoAddBolseiro() {
    this.router.navigate(['gestao-bolseiros/bolseiros/cadastrar-bolseiro'], {
      queryParams: {
        bolseiroId: this.bolseiroID,
      },
    });
  }
}
